import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { fingerprint } from 'utils/helpers';

export type CreateSessionContextPayload = {
  device: 'MOBILE' | 'DESKTOP' | 'OTHERS';
  meta?: Record<string, any>;
  key?: string;
};

export default function useCreateSessionContext() {
  return useMutation({
    mutationFn: async (payload: CreateSessionContextPayload) => {
      const request = await axios.post(
        `${import.meta.env.VITE_APP_END_POINT}/api/v2/sessions/contexts`,
        {
          deviceId: await fingerprint(),
          ...payload,
        },
        {
          headers: {
            Authorization: import.meta.env.VITE_APP_BASIC_AUTH,
          },
        },
      );

      return request?.data?.data;
    },
  });
}
